module.exports = "/_next/static/images/bca-logo-bfdfa1903346031727e9b2397905cbe2.svg";